import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import './ThemeToggle.css';

interface ThemeToggleProps {
  className?: string;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      className={`theme-toggle ${className}`}
      onClick={toggleTheme}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      <div className="theme-toggle-inner">
        <div className="theme-toggle-icon">
          {theme === 'light' ? (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="5"></circle>
              <path d="m12 1 0 2"></path>
              <path d="m12 21 0 2"></path>
              <path d="m4.22 4.22 1.42 1.42"></path>
              <path d="m18.36 18.36 1.42 1.42"></path>
              <path d="m1 12 2 0"></path>
              <path d="m21 12 2 0"></path>
              <path d="m4.22 19.78 1.42-1.42"></path>
              <path d="m18.36 5.64 1.42-1.42"></path>
            </svg>
          )}
        </div>
        <span className="theme-toggle-text">
          {theme === 'light' ? 'Dark' : 'Light'}
        </span>
      </div>
    </button>
  );
};

export default ThemeToggle;


















